import styled from "styled-components";

export const SectionWrapper = styled.div`
    border: 1px solid #ddd;
    padding: 35px 25px 25px;
    border-radius: 5px;
    margin-bottom: 15px;
    position: relative;
    overflow: hidden;

    .add-row {
        background: #fafafa;
        margin-bottom: 25px;

        p {
            font-size: 13px;
            font-weight: 300;
        }
    }

    .add-section {
        p {
            font-size: 13px;
            font-weight: 300;
        }
    }
    .remove-btn {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }
`;

export const StyledIFrame = styled.embed`
    border: 0;
`;
